const info = 
{
    title: "Good Game",
    type: "Novel/Script"
};

export default info;